"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var status = props.status,
      progress = props.progress,
      setUploader = props.setUploader,
      onDelete = props.onDelete,
      canDelete = props.canDelete,
      _props$id = props.id,
      id = _props$id === void 0 ? '' : _props$id,
      style = props.style,
      _props$value = props.value,
      value = _props$value === void 0 ? {} : _props$value,
      ActionComponent = props.ActionComponent,
      triggerUpload = props.triggerUpload,
      FooterComponent = props.FooterComponent,
      DisplayComponent = props.DisplayComponent;
  return _react["default"].createElement("div", {
    className: "spaui-upmedia-inner",
    id: id,
    style: style
  }, _react["default"].createElement("div", {
    className: "spaui-upmedia-media"
  }, _react["default"].createElement(DisplayComponent, {
    data: value
  })), // 失败显示的结构
  status === 'fail' || status === 'error' ? _react["default"].createElement("div", {
    className: "spaui-upmedia-status"
  }, _react["default"].createElement("i", {
    className: "spaui-upmedia-icon"
  }), _react["default"].createElement("span", {
    className: "spaui-upmedia-label"
  }, value.label || '上传失败')) : null, // 上传中
  status === 'uploading' ? _react["default"].createElement("div", {
    className: "spaui-upmedia-status"
  }, _react["default"].createElement("i", {
    className: "spaui-upmedia-icon"
  }), _react["default"].createElement("span", {
    className: "spaui-upmedia-label"
  }, value.label || '上传中...'), _react["default"].createElement("progress", {
    className: "spaui-upmedia-progress",
    value: progress,
    max: "100"
  })) : null, // 上传成功自定义组件
  status === 'success' && typeof ActionComponent !== 'undefined' ? _react["default"].createElement(ActionComponent, {
    className: "spaui-upmedia-action",
    triggerUpload: triggerUpload,
    value: value
  }) : null, // 上传成功尾部组件
  status === 'success' && typeof FooterComponent !== 'undefined' ? _react["default"].createElement(FooterComponent, {
    className: "spaui-upmedia-footer",
    value: value
  }) : null, // 上传成功且支持上传
  status === 'success' && setUploader ? setUploader(_react["default"].createElement("span", null)) : null, // 可以删除
  canDelete ? _react["default"].createElement("a", {
    className: "spaui-upmedia-del",
    href: "javascript:;",
    onClick: onDelete
  }, _react["default"].createElement("i", {
    className: "spaui-upmedia-icon-del"
  })) : null);
};

exports["default"] = _default;